import React from "react";

const SkeletonBlock = ({ className }) => (
  <div className={`animate-pulse rounded bg-slate-200 ${className}`} />
);

export default function LoadingState({ variant = "card", rows = 5 }) {
  if (variant === "table") {
    return (
      <div className="card p-5">
        <div className="mb-4 flex gap-2">
          <SkeletonBlock className="h-4 w-36" />
          <SkeletonBlock className="h-4 w-24" />
        </div>
        <div className="space-y-3">
          {Array.from({ length: rows }).map((_, index) => (
            <div key={`row-${index}`} className="flex gap-3">
              <SkeletonBlock className="h-4 w-28" />
              <SkeletonBlock className="h-4 w-36" />
              <SkeletonBlock className="h-4 w-24" />
              <SkeletonBlock className="h-4 w-32" />
              <SkeletonBlock className="h-4 w-28" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === "cards") {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: rows }).map((_, index) => (
          <div key={`card-${index}`} className="card p-5">
            <SkeletonBlock className="h-3 w-24" />
            <SkeletonBlock className="mt-4 h-8 w-20" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="card p-5">
      <SkeletonBlock className="h-4 w-44" />
      <SkeletonBlock className="mt-4 h-3 w-full" />
    </div>
  );
}
